import * as Cesium from 'cesium'
import { generateCircularPolygon, setCameraScene, setViewScene } from '/@/utils/kmlParse'
import emitter from '/@/event-bus'
const Ti = {
  class: 'val'
}
class DrawCircleTool {
    private viewer: Cesium.Viewer;
    private dataSource: Cesium.CustomDataSource;
    private centerEntity: Cesium.Entity;
    private borderEntity: Cesium.Entity;
    private circleEntity: Cesium.Entity;
    private radiusText: Cesium.Entity;
    private material;
    private line: Cesium.Entity | null;
    private centerPos: { lng: any; lat: any; height: any; } | null
    private borderPos: { lng: number; lat: number; height: number; } | null
    private radius
    private positions: any[] | undefined
    private editColor
    private circleColor
    private selectNodeType
    private startTime
    private createHandler
    private editHandler
    private isDrawing: boolean // 标记是否正在绘制
    private completedCircles: Cesium.Entity[] // 保存已完成的圆
    private currentCircleId: number // 当前圆的ID
    private _createMoveEvent = (event: { endPosition: any; }) => {
      if (!this.centerEntity || !this.borderEntity || !this.circleEntity) {
        return
      }

      const pickResult = this._getPickObject(event.endPosition, this.viewer)
      const point = pickResult?.position
      if (!point) {
        return
      }

      const mouseCartesian = this.cartographic2latlngHeight(point)
      if (!mouseCartesian) {
        return
      }

      if (this.centerPos) {
        // 计算实时半径（圆心到鼠标点的距离）
        this.radius = this.twoPointsDistance(this.centerPos, mouseCartesian)
        this.radius = Math.max(this.radius, 0.5)

        // 使用新的方法计算边界点位置（沿着圆心到鼠标点的方向）
        const borderPoint = this.getCircleBorderCoordinate(this.centerPos, mouseCartesian, this.radius)
        const borderCartesian = Cesium.Cartesian3.fromDegrees(
          borderPoint.lng,
          borderPoint.lat,
          borderPoint.height
        )

        // 更新边界点实体位置
        if (this.borderEntity) {
          this.borderEntity.position = borderCartesian
          this.borderPos = borderPoint

          // 确保边界点可见
          if (this.borderEntity.point) {
            this.borderEntity.point.show = true
          }
        }

        // 更新半径文本
        if (this.radiusText && this.centerPos && this.borderPos) {
          const textPosition = this.getCenterTwoPoints(this.centerPos, this.borderPos)
          this.radiusText.position = Cesium.Cartesian3.fromDegrees(
            textPosition.lng,
            textPosition.lat,
            textPosition.height
          )
          this.radiusText.label.text = `${this.radius.toFixed(2)}m`
          this.radiusText.label.show = true
        }

        // 更新圆形
        this.positions = this.calculateCirclePoints(this.centerPos, this.radius)
        this._updateCircleEntity()
      }
    }

    constructor (viewer: Cesium.Viewer) {
      this.viewer = viewer
      this.dataSource = new Cesium.CustomDataSource('circle_draw')
      this.centerEntity = null
      this.borderEntity = null
      this.circleEntity = null
      this.radiusText = null
      this.material = {}
      this.line = null
      this.centerPos = null
      this.borderPos = null
      this.radius = 0.5
      this.positions = []
      this.selectNodeType = ''
      this.startTime = 0
      this.createHandler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas)
      this.editHandler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas)
      this.circleColor = '#2d8cf0'
      this.editColor = '#2d8cf0'
      this.isDrawing = false
      this.completedCircles = []
      this.currentCircleId = 0
      this.setDrawColor(this.circleColor)
    }

    /**
     * 重置绘制状态
     */
    private _resetDrawingState () {
      this._clearEntity()
      this._clearCreateHandler()

      this.centerPos = null
      this.borderPos = null
      this.radius = 0.5
      this.positions = []
      this.selectNodeType = ''
      this.isDrawing = false
      this.circleEntity = null
    }

    startDraw () {
      if (this.isDrawing) {
        console.warn('正在绘制中，请先完成当前绘制')
        return
      }

      this.isDrawing = true
      this.currentCircleId++
      this._registerEvents()
    }

    endDraw () {
      this._clearHandler()
      this._clearCreateEntity()
    }

    startEdit (centerPoint: { lng: any; lat: any; }, radius: number) {
      const point = this.calculateCirclePoints(centerPoint, radius)
      this.radius = radius
      this.centerPos = centerPoint
      this.positions = point
      this.borderPos = this.getCircleBorderCoordinate({
        lng: centerPoint.lng,
        lat: centerPoint.lat
      }, {
        lng: centerPoint.lng,
        lat: centerPoint.lat
      }, radius)
      this._setEdit()
      this._registerEditEvents()
    }

    updateCircle (centerPoint: any[], radius: number) {
      const point = {
        lng: centerPoint[0],
        lat: centerPoint[1],
        height: 0
      }
      const cartesian = radius
      this.centerPos = point
      this.radius = radius
      this._updateCircle(point, cartesian)
      const p = this.getCircleInfo(this.radius)
    //   emitter.emit('updateCircleInfo', {
    //     type: 'circle',
    //     entity: this.circleEntity,
    //     radius: Number.parseFloat(this.radius.toFixed(2)),
    //     center: [this.centerPos.lng, this.centerPos.lat, this.centerPos.height],
    //     area: Number.parseFloat(p.area.toFixed(2)),
    //     lnglatList: this.cartographic2latlngHeightArray(this.positions),
    //     perimeter: p.perimeter.toFixed(2),
    //     color: this.editColor
    //   })
    }

    private _updateCircle (centerPoint: { lng: any; lat: any; height: any; }, radius: any) {
      const point = this.getCircleBorderCoordinate(centerPoint, centerPoint, radius)
      const cartesian = Cesium.Cartesian3.fromDegrees(point.lng, point.lat, point.height)
      if (this.borderEntity && this.centerEntity && this.radiusText) {
        this.borderEntity.position = cartesian
        this.borderPos = point
        this.centerEntity.position = Cesium.Cartesian3.fromDegrees(centerPoint.lng, centerPoint.lat, centerPoint.height)
        this.positions = this.calculateCirclePoints(centerPoint, radius)
        const p = this.getCenterTwoPoints(centerPoint, this.borderPos)
        this.radiusText.position = Cesium.Cartesian3.fromDegrees(p.lng, p.lat, p.height)
        this.radiusText.label.text = `${this.radius.toFixed(2)}m`
      }
    }

    endEdit () {
      this._clearEditHandlerAndEntity()
      this._clearCreateHandler()
      if (this.centerPos) {
        this.circleEntity = this._drawResultCircle(this.centerPos, this.radius)
        this.circleEntity.info = {
          radius: this.radius,
          center: JSON.parse(JSON.stringify(this.centerPos)),
          border: JSON.parse(JSON.stringify(this.borderPos)),
          lngLatHeight: JSON.parse(JSON.stringify(this.positions))
        }
        const circleInfo = this.getCircleInfo(this.radius)
        // emitter.emit('endEditCircle', {
        //   type: 'circle',
        //   entity: this.circleEntity,
        //   radius: Number.parseFloat(this.radius.toFixed(2)),
        //   center: [this.centerPos.lng, this.centerPos.lat, this.centerPos.height],
        //   area: Number.parseFloat(circleInfo.area.toFixed(2)),
        //   lnglatList: this.positions,
        //   perimeter: circleInfo.perimeter.toFixed(2),
        //   color: this.circleColor
        // })
      }
      return this.circleEntity
    }

    setEditColor (color: string) {
      this.editColor = color
      if (this.circleEntity && this.line && this.line.polyline) {
        this.circleEntity.polygon.material = Cesium.Color.fromCssColorString(color).withAlpha(0.4)
        this.circleEntity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
          color: Cesium.Color.fromCssColorString(color),
          outlineColor: new Cesium.Color(1, 1, 1, 1),
          outlineWidth: 3
        })
        this.line.polyline.material = new Cesium.PolylineDashMaterialProperty({
          color: Cesium.Color.fromCssColorString(color),
          dashLength: 20
        })
      }
    }

    setDrawColor (color: string) {
      this.circleColor = color
      this.setEditColor(color)
      this.material.circlePolygon = {
        material: Cesium.Color.fromCssColorString(color).withAlpha(0.4)
      }
      this.material.circlePolyline = {
        width: 4,
        material: new Cesium.PolylineOutlineMaterialProperty({
          color: Cesium.Color.fromCssColorString(color),
          outlineColor: new Cesium.Color(1, 1, 1, 1),
          outlineWidth: 3
        })
      }
      this.material.centerPoint = {
        size: 10,
        color: Cesium.Color.WHITE,
        show: true
      }
      this.material.boarderPoint = {
        size: 12, // 增大尺寸
        color: Cesium.Color.WHITE, // 使用黄色，更明显
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 2,
        show: true
      }
      this.material.line = {
        width: 4,
        material: new Cesium.PolylineDashMaterialProperty({
          color: Cesium.Color.fromCssColorString(color),
          dashLength: 20
        }),
        show: true
      }
    }

    destory () {
      this._clearEntity()
      this._clearHandler()
      this._clearEventBus()
      this.removeAllCircles()
    }

    _setEdit () {
      if (this.centerPos && this.borderPos) {
        const editPoint = this._createEditNodePoint(this.centerPos, this.borderPos)
        this.centerEntity = editPoint.center
        this.borderEntity = editPoint.boarderPoint
        this.line = this._createLineBetweenCenterBoarder()
        this.radiusText = this._addRadiusText()
        const centerPosition = this.getCenterTwoPoints(this.centerPos, this.borderPos)
        this.radiusText.position = Cesium.Cartesian3.fromDegrees(centerPosition.lng, centerPosition.lat, centerPosition.height)
        this.radiusText.label.text = `${this.radius.toFixed(2)}m`
        this.circleEntity = this._drawEditingCircle(this.centerPos, this.radius)
        this.positions = this.calculateCirclePoints(this.centerPos, this.radius)
        this.circleEntity.info = {
          radius: this.radius,
          center: this.centerPos,
          border: this.borderPos,
          lngLatHeight: this.positions
        }
      }
    }

    _registerEvents () {
      this._registerCreateEvents()
      this._registerEditEvents()
    }

    _getPickObject (position: any, viewer: Cesium.Viewer) {
      let event, pick
      const ray = new Cesium.Ray()
      const scene = viewer.scene
      let i
      if (scene.mode !== Cesium.SceneMode.MORPHING) {
        if (scene.pickPositionSupported) {
          event = viewer.scene.pickPosition(position, i)
        }
        pick = scene.pick(position)
        if (Cesium.defined(pick)) {
          const pickRay = scene.camera.getPickRay(position, ray)
          pickRay && (event = scene.globe.pick(pickRay, scene, i))
        } else if (viewer.terrainProvider instanceof Cesium.EllipsoidTerrainProvider) { event = viewer.camera.pickEllipsoid(position, scene.globe.ellipsoid, i) } else {
          const pickRay = scene.camera.getPickRay(position, ray)
          pickRay && (event = scene.globe.pick(pickRay, scene, i))
        }
      }
      if (Cesium.defined(event) || Cesium.defined(pick)) {
        return {
          pickedObject: pick,
          position: event,
          screenPosition: position
        }
      }
    }

    /**
 * 更新圆形实体显示
 */
    private _updateCircleEntity () {
      if (!this.circleEntity || !this.positions) {
        return
      }

      // 由于使用了CallbackProperty，我们需要触发其重新计算
      // 可以通过临时修改positions引用来触发更新
      const tempPositions = [...this.positions]
      this.positions = tempPositions
    }

    _registerCreateEvents () {
      this.createHandler.setInputAction((event: { position: any; }) => {
        const pickObject = this._getPickObject(event.position, this.viewer)
        const position = pickObject?.position

        if (!position) return

        const latLng = this.cartographic2latlngHeight(position)
        if (!latLng) return

        if (!this.centerPos) {
          // 第一次点击：设置中心点
          this._startNewCircle(latLng)
        } else {
          // 第二次点击：完成绘制
          this._completeCircleDrawing(latLng, pickObject)
        }
      }, Cesium.ScreenSpaceEventType.LEFT_DOWN)
    }

    /**
 * 开始绘制新圆
 */
    private _startNewCircle (latLng: { lng: number; lat: number; height: number }) {
      this.radius = 0.5
      this.editColor = this.circleColor
      this.centerPos = latLng

      // 初始边界点与中心点相同
      this.borderPos = { ...latLng }

      // 创建编辑节点
      const nodePoint = this._createInitEditNodePoint(latLng)
      this.centerEntity = nodePoint.center
      this.borderEntity = nodePoint.boarderPoint

      // 确保边界点初始可见
      if (this.borderEntity.point) {
        this.borderEntity.point.show = true
      }

      // 创建圆形实体
      this.circleEntity = this._drawEditingCircle(this.centerPos, this.radius)
      this.radiusText = this._addRadiusText()
      this.line = this._createLineBetweenCenterBoarder()

      // 确保线可见
      if (this.line.polyline) {
        this.line.polyline.show = true
      }

      // 注册鼠标移动事件
      this.createHandler.setInputAction(this._createMoveEvent, Cesium.ScreenSpaceEventType.MOUSE_MOVE)
    }

    /**
 * 完成圆形绘制
 */
    private _completeCircleDrawing (latLng: { lng: number; lat: number; height: number }, pickObject: any) {
      const pickedObject = pickObject?.pickedObject

      // 点击边界点完成绘制
      if ((pickedObject?.id?.typeInfo === 'editing-circle-entity' || pickedObject?.id?.typeInfo === 'init-border-point-edit') && this.radius > 0) {
        this.radius = this.twoPointsDistance(this.centerPos, latLng)
        this.completeCurrentCircle()
        this._registerCreateEvents()
      }
    }

    /**
     * 完成当前圆的绘制并保存
     */
    /**
 * 完成当前圆的绘制并保存
 */
    completeCurrentCircle () {
      if (!this.isDrawing || !this.centerPos) {
        return null
      }

      // 创建最终的圆实体（非编辑状态）
      const finalCircle = this._createFinalCircle(this.centerPos, this.radius)

      // 计算圆的顶点坐标
      const circlePositions = this.calculateCirclePoints(this.centerPos, this.radius)
      const latlngList = this.cartographic2latlngHeightArray(circlePositions)

      // 保存圆的信息
      const circleInfo = this.getCircleInfo(this.radius)
      finalCircle.circleInfo = {
        id: this.currentCircleId,
        radius: Number.parseFloat(this.radius.toFixed(2)),
        center: [this.centerPos.lng, this.centerPos.lat, this.centerPos.height],
        area: Number.parseFloat(circleInfo.area.toFixed(2)),
        perimeter: circleInfo.perimeter.toFixed(2),
        color: this.circleColor,
        createTime: new Date().toISOString(),
        entity: finalCircle
      }

      // 添加到已完成列表
      this.completedCircles.push(finalCircle)

      // 发射飞行区域事件
      emitter.emit('flightAreasDroneLocation', finalCircle.circleInfo)

      // 发射标记元素信息事件
      const info = {
        color: this.circleColor,
        position: finalCircle.circleInfo.center, // 转换为所需格式
        radius: finalCircle.circleInfo.radius,
      }
      console.log(info, 'elementMarkInfo==>circle')
      emitter.emit('elementMarkInfo', info)

      // 重置绘制状态，关闭当前绘制图形
      this._resetDrawingState()
      this.viewer.entities.remove(this.centerEntity)
      this.viewer.entities.remove(this.borderEntity)
      this.viewer.entities.remove(this.circleEntity)
      this.viewer.entities.remove(this.radiusText)
      this.viewer.entities.remove(this.line)
      this.centerEntity = null
      this.borderEntity = null
      this.circleEntity = null
      this.radiusText = null
      this.line = null
      this.removeAllCircles()
      return finalCircle
    }

    /**
     * 根据ID获取特定的圆
     */
    getCircleById (id: number): Cesium.Entity | undefined {
      return this.completedCircles.find(circle =>
        circle.circleInfo && circle.circleInfo.id === id
      )
    }

    /**
     * 删除指定的圆
     */
    removeCircle (circle: Cesium.Entity): boolean {
      const index = this.completedCircles.indexOf(circle)
      if (index !== -1) {
        this.viewer.entities.remove(circle)
        this.completedCircles.splice(index, 1)
        // emitter.emit('circleRemoved', { circle })
        return true
      }
      return false
    }

    /**
     * 删除所有圆
     */
    removeAllCircles (): void {
      this.completedCircles.forEach(circle => {
        this.viewer.entities.remove(circle)
      })
      this.completedCircles = []
    //   emitter.emit('allCirclesRemoved')
    }

    /**
     * 获取所有已完成的圆
     */
    getCompletedCircles (): Cesium.Entity[] {
      return [...this.completedCircles]
    }

    /**
     * 创建最终的圆（非编辑状态）
     */
    private _createFinalCircle (point: any, radius: number): Cesium.Entity {
      const positions = this.calculateCirclePoints(point, radius)
      const entity = this.viewer.entities.add({
        polygon: {
          hierarchy: new Cesium.PolygonHierarchy(positions),
          material: Cesium.Color.fromCssColorString(this.circleColor).withAlpha(0.4),
          classificationType: Cesium.ClassificationType.BOTH
        },
        polyline: {
          positions: positions,
          width: 4,
          material: new Cesium.PolylineOutlineMaterialProperty({
            color: Cesium.Color.fromCssColorString(this.circleColor),
            outlineColor: Cesium.Color.WHITE,
            outlineWidth: 3
          }),
          clampToGround: true,
          classificationType: Cesium.ClassificationType.BOTH
        }
      })

      entity.typeInfo = 'final-circle'
      return entity
    }

    /**
 * 注册圆形要素的编辑事件（拖拽编辑）
 */
    _registerEditEvents () {
    // 鼠标左键按下事件 - 开始编辑
      this.editHandler.setInputAction((event: { position: any; }) => {
        const pickObject = this._getPickObject(event.position, this.viewer)

        if (pickObject != null && pickObject.position) {
          this.startTime = Date.now()

          const pickedObject = pickObject.pickedObject
          if (!pickedObject || !pickedObject.id) return

          // 判断点击的是中心点还是边界点
          if (pickedObject.id.typeInfo === 'center-edit') {
            setCameraScene(this.viewer) // 可能是进入编辑模式的函数
            this.selectNodeType = 'center' // 选择中心点编辑
          } else if (pickedObject.id.typeInfo === 'border-point-edit') {
            setCameraScene(this.viewer) // 可能是进入编辑模式的函数
            this.selectNodeType = 'border' // 选择边界点编辑
          }
        }
      }, Cesium.ScreenSpaceEventType.LEFT_DOWN)

      // 鼠标移动事件 - 实时更新
      this.editHandler.setInputAction((event: { endPosition: any; }) => {
        const pickObject = this._getPickObject(event.endPosition, this.viewer)
        const position = pickObject?.position

        if (!position) return

        const pickedPosition = this.cartographic2latlngHeight(position)

        if (this.selectNodeType === 'center') {
          // 拖动中心点：整个圆形移动
          if (this.centerPos && pickedPosition && this.centerEntity && this.borderEntity) {
            // 保持边界点相对于中心点的位置
            const borderPoint = this.getCircleBorderCoordinate(this.centerPos, pickedPosition, this.radius)
            const borderCartesian = Cesium.Cartesian3.fromDegrees(
              borderPoint.lng,
              borderPoint.lat,
              borderPoint.height
            )

            // 更新实体位置
            this.borderEntity.position = borderCartesian
            this.borderPos = borderPoint
            this.centerEntity.position = position
            this.centerPos = pickedPosition

            // 重新计算圆形边界点
            this.positions = this.calculateCirclePoints(this.centerPos, this.radius)

            // 更新半径文本位置和内容
            const textPosition = this.getCenterTwoPoints(this.centerPos, this.borderPos)
            this.radiusText.position = Cesium.Cartesian3.fromDegrees(
              textPosition.lng,
              textPosition.lat,
              textPosition.height
            )
            this.radiusText.label.text = `${this.radius.toFixed(2)}m`
          }
        } else if (this.selectNodeType === 'border') {
          // 拖动边界点：改变半径
          if (pickedPosition && this.borderEntity && this.centerPos) {
            this.borderEntity.position = position
            this.borderPos = pickedPosition

            // 计算新的半径
            this.radius = this.twoPointsDistance(this.centerPos, pickedPosition)

            // 更新半径文本位置和内容
            const textPosition = this.getCenterTwoPoints(this.centerPos, this.borderPos)
            this.radiusText.position = Cesium.Cartesian3.fromDegrees(
              textPosition.lng,
              textPosition.lat,
              textPosition.height
            )
            this.radiusText.label.text = `${this.radius.toFixed(2)}m`

            // 重新计算圆形边界点
            if (this.centerPos) {
              this.positions = this.calculateCirclePoints(this.centerPos, this.radius)
            }
          }
        }
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)

      // 鼠标左键释放事件 - 结束编辑
      this.editHandler.setInputAction(() => {
        setViewScene(this.viewer) // 可能恢复视角设置

        if (this.selectNodeType === 'border' || this.selectNodeType === 'center') {
          this._updateCircleInfo() // 更新圆形信息
          this.selectNodeType = '' // 清除选择状态
        }
      }, Cesium.ScreenSpaceEventType.LEFT_DOWN)
    }

    _clearCreateEntity () {
      this._clearEntity()
      this.positions = []
    }

    _endCreateCircle () {
      this._clearCreateHandler()
      this._clearCreateEntity()
    }

    _updateCircleInfo () {
      const circleInfo = this.getCircleInfo(this.radius)
      if (this.centerPos) {
        const circlePoints = this.calculateCirclePoints(this.centerPos, this.radius)
        const lanLng = this.cartographic2latlngHeightArray(circlePoints)
        // emitter.emit('updateCircleInfo', {
        //   type: 'circle',
        //   entity: this.circleEntity,
        //   radius: Number.parseFloat(this.radius.toFixed(2)),
        //   center: [this.centerPos.lng, this.centerPos.lat, this.centerPos.height],
        //   area: Number.parseFloat(circleInfo.area.toFixed(2)),
        //   lnglatList: lanLng,
        //   perimeter: circleInfo.perimeter.toFixed(2),
        //   color: this.editColor
        // })
      }
    }

    clearAllEntity () {
      const entitiesToRemove = [
        this.centerEntity,
        this.borderEntity,
        this.circleEntity,
        this.line,
        this.radiusText,
        ...this.completedCircles,
      ].filter(entity => entity !== null) as Cesium.Entity[]
      entitiesToRemove.forEach(entity => {
        this.viewer.entities.remove(entity)
      })

      this.centerEntity = null
      this.borderEntity = null
      // 只重置编辑中的圆实体，不重置已完成的圆
      if (this.circleEntity) {
        this.circleEntity = null
      }
      this.line = null
      this.radiusText = null
    }

    _clearEntity () {
      // 只清除编辑相关的临时实体，不删除已完成的圆
      const entitiesToRemove = [
        this.centerEntity,
        this.borderEntity,
        this.circleEntity?.typeInfo === 'editing-circle-entity' ? this.circleEntity : null,
        this.line,
        this.radiusText
      ].filter(entity => entity !== null) as Cesium.Entity[]

      entitiesToRemove.forEach(entity => {
        this.viewer.entities.remove(entity)
      })

      this.centerEntity = null
      this.borderEntity = null
      // 只重置编辑中的圆实体，不重置已完成的圆
      if (this.circleEntity?.typeInfo === 'editing-circle-entity') {
        this.circleEntity = null
      }
      this.line = null
      this.radiusText = null
    }

    _clearCreateHandler () {
      this.createHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOWN)
      this.createHandler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE)
    }

    _clearEditHandler () {
      this.editHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOWN)
      this.editHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOWN)
      this.editHandler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE)
      this.editHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOWN)
    }

    _clearHandler () {
      this._clearCreateHandler()
      this._clearEditHandler()
    }

    _clearEventBus () {
      // emitter.off('updateCircleInfo')
      // emitter.off('endCreateCircle')
    }

    _clearEditHandlerAndEntity () {
      this._clearEditHandler()
      this._clearEntity()
      this.positions = []
    }

    _createInitEditNodePoint (point: { lng: any; lat: any; height: any; }) {
      const entity = this.viewer.entities.add({
        position: Cesium.Cartesian3.fromDegrees(point.lng, point.lat, point.height),
        point: {
          pixelSize: this.material.centerPoint.size,
          color: this.material.centerPoint.color,
          show: true,
          disableDepthTestDistance: 3e6,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
        }
      })
      entity.typeInfo = 'init-center-edit'

      // 修改边界点：使用point而不是billboard，确保显示出来
      const border = this.viewer.entities.add({
        position: Cesium.Cartesian3.fromDegrees(point.lng, point.lat, point.height),
        point: {
          pixelSize: this.material.boarderPoint.size,
          color: this.material.boarderPoint.color,
          show: true,
          disableDepthTestDistance: 3e6,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
        }
      })
      border.typeInfo = 'init-border-point-edit'

      return {
        center: entity,
        boarderPoint: border
      }
    }

    _createLineBetweenCenterBoarder () {
      const entity = this.viewer.entities.add({
        polyline: {
          positions: new Cesium.CallbackProperty(() => {
            if (this.centerPos && this.borderPos) {
              return [
                Cesium.Cartesian3.fromDegrees(this.centerPos.lng, this.centerPos.lat, this.centerPos.height),
                Cesium.Cartesian3.fromDegrees(this.borderPos.lng, this.borderPos.lat, this.borderPos.height)
              ]
            }
            return []
          }, false),
          width: this.material.line.width,
          material: this.material.line.material,
          clampToGround: true,
          classificationType: Cesium.ClassificationType.BOTH
        }
      })
      entity.typeInfo = 'line-between-center-boarder-edit'
      return entity
    }

    _createEditNodePoint (point: { lng: number; lat: number; height: number | undefined; }, position: { lng: number; lat: number; height: number | undefined; }) {
      const entity = this.viewer.entities.add({
        position: Cesium.Cartesian3.fromDegrees(point.lng, point.lat, point.height),
        point: {
          pixelSize: this.material.centerPoint.size,
          color: this.material.centerPoint.color,
          show: true,
          disableDepthTestDistance: 3e6,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
        }
      })
      entity.typeInfo = 'center-edit'
      const points = this.viewer.entities.add({
        position: Cesium.Cartesian3.fromDegrees(position.lng, position.lat, position.height),
        point: {
          pixelSize: this.material.boarderPoint.size,
          color: this.material.boarderPoint.color,
          show: true,
          disableDepthTestDistance: 3e6,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
        }
      })
      points.typeInfo = 'border-point-edit'
      return {
        center: entity,
        boarderPoint: points
      }
    }

    _drawEditingCircle (point: any, radius: number) {
      this.positions = this.calculateCirclePoints(point, radius)
      const entity = this.viewer.entities.add({
        polygon: {
          hierarchy: new Cesium.CallbackProperty(() => new Cesium.PolygonHierarchy(this.positions), false),
          material: this.material.circlePolygon.material,
          classificationType: Cesium.ClassificationType.BOTH
        },
        polyline: {
          positions: new Cesium.CallbackProperty(() => this.positions, false),
          width: this.material.circlePolyline.width,
          material: this.material.circlePolyline.material,
          clampToGround: true,
          classificationType: Cesium.ClassificationType.BOTH
        }
      })
      entity.typeInfo = 'editing-circle-entity'
      return entity
    }

    _drawResultCircle (point: any, radius: number) {
      const position = this.calculateCirclePoints(point, radius)
      const entity = this.viewer.entities.add({
        polygon: {
          hierarchy: new Cesium.PolygonHierarchy(position),
          material: this.material.circlePolygon.material,
          classificationType: Cesium.ClassificationType.BOTH
        },
        polyline: {
          positions: position,
          width: this.material.circlePolyline.width,
          material: this.material.circlePolyline.material,
          clampToGround: true,
          classificationType: Cesium.ClassificationType.BOTH
        }
      })
      entity.polygon.material = Cesium.Color.fromCssColorString(this.editColor).withAlpha(0.4)
      entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
        color: Cesium.Color.fromCssColorString(this.editColor),
        outlineColor: new Cesium.Color(1, 1, 1, 1),
        outlineWidth: 3
      })
      entity.typeInfo = 'circle-entity'
      //   emitter.emit('startNextCircle', entity)
      return entity
    }

    _addRadiusText () {
      const entity = this.viewer.entities.add({
        label: {
          show: true,
          showBackground: true,
          font: '14px monospace',
          pixelOffset: new Cesium.Cartesian2(5, 5),
          disableDepthTestDistance: Number.POSITIVE_INFINITY
        }
      })
      entity.typeInfo = 'radius-text'
      return entity
    }

    getCircleInfo (number: number) {
      const area = Number.parseFloat((Math.PI * number * number).toFixed(2))
      const perimeter = Number.parseFloat((2 * Math.PI * number).toFixed(2))
      return {
        area: area,
        perimeter: perimeter
      }
    }

    calculateCirclePoints (point: { lng: number; lat: number; }, radius: number, steps = 64) {
      const positions: Cesium.Cartesian3[] = []
      const centerCartographic = Cesium.Cartographic.fromDegrees(point.lng, point.lat)

      for (let i = 0; i < steps; i++) {
        const angle = (i / steps) * 2 * Math.PI

        // 使用球面坐标计算圆上的点
        const lat = point.lat + (radius / 111320) * Math.cos(angle)
        const lng = point.lng + (radius / (111320 * Math.cos(point.lat * Math.PI / 180))) * Math.sin(angle)

        const height = this.getTerrainHeight({ lng, lat }, this.viewer)
        positions.push(Cesium.Cartesian3.fromDegrees(lng, lat, height))
      }

      // 闭合圆形
      if (positions.length > 0) {
        positions.push(positions[0].clone())
      }

      return positions
    }

    getCircleBorderCoordinate (centerPoint: { lng: number; lat: number; }, mousePoint: { lng: number; lat: number; }, radius: number) {
      // 计算圆心到鼠标点的方向角度
      const dLng = mousePoint.lng - centerPoint.lng
      const dLat = mousePoint.lat - centerPoint.lat

      // 计算角度（弧度）
      const angle = Math.atan2(dLat, dLng)

      // 根据角度和半径计算边界点位置
      const borderLng = centerPoint.lng + (radius / (111320 * Math.cos(centerPoint.lat * Math.PI / 180))) * Math.cos(angle)
      const borderLat = centerPoint.lat + (radius / 111320) * Math.sin(angle)

      return {
        lng: borderLng,
        lat: borderLat,
        height: this.getTerrainHeight({ lng: borderLng, lat: borderLat }, this.viewer)
      }
    }

    /**
 * 获取指定经纬度的地形高度
 * @param {Object} position - 包含 lng, lat 的位置对象
 * @param {Object} viewer - Cesium 查看器实例
 * @returns {number} 地形高度（米），精度7位小数
 */
    getTerrainHeight (position: { lng: any; lat: any; }, viewer: Cesium.Viewer) {
      const { lng, lat } = position

      // 创建地图坐标并获取高度
      const cartographic = Cesium.Cartographic.fromDegrees(lng, lat, 0)
      const terrainHeight = viewer.scene.globe.getHeight(cartographic)

      // 处理空值并格式化精度
      return Number.parseFloat((terrainHeight ?? 0).toFixed(7))
    }

    getCenterTwoPoints (position: { lng: any; lat: any; }, point: { lng: any; lat: any; }) {
      const lng = (position.lng + point.lng) / 2
      const lat = (position.lat + point.lat) / 2
      const p = this.getTerrainHeight({
        lng: lng,
        lat: lat
      }, this.viewer)
      return {
        lng: lng,
        lat: lat,
        height: p
      }
    }

    twoPointsDistance (firstPoint: { lng: number; lat: number; height?: number }, secondPoint: { lng: number; lat: number; height?: number }) {
      const left = Cesium.Cartesian3.fromDegrees(
        firstPoint.lng,
        firstPoint.lat,
        firstPoint.height || 0
      )
      const right = Cesium.Cartesian3.fromDegrees(
        secondPoint.lng,
        secondPoint.lat,
        secondPoint.height || 0
      )
      return Cesium.Cartesian3.distance(left, right)
    }

    cartographic2latlngHeight (position: Cesium.Cartesian3) {
      if (!position) return null
      const cartesian = Cesium.Cartographic.fromCartesian(position)
      const lng = Cesium.Math.toDegrees(cartesian.longitude).toFixed(7)
      const lat = Cesium.Math.toDegrees(cartesian.latitude).toFixed(7)
      const height = cartesian.height.toFixed(4)
      return {
        lng: Number.parseFloat(lng),
        lat: Number.parseFloat(lat),
        height: Number.parseFloat(height)
      }
    }

    cartographic2latlngHeightArray (points: any[]) {
      const list: number[][] = []
      points.forEach((item: any) => {
        const latLng = this.cartographic2latlngHeight(item)
        if (latLng) list.push([latLng.lng, latLng.lat, latLng.height])
      })
      return list
    }

    latlngHeight2cartographic (points: any[]) {
      const list: Cesium.Cartesian3[] = []
      points.forEach((item: { lng: number; lat: number; height: number | undefined; }) => {
        const position = Cesium.Cartesian3.fromDegrees(item.lng, item.lat, item.height)
        list.push(position)
      })
      return list
    }

    latlng2cartographic (points: any[]) {
      const list: Cesium.Cartesian3[] = []
      points.forEach((item: { lng: number; lat: number; }) => {
        const postion = Cesium.Cartesian3.fromDegrees(item.lng, item.lat)
        list.push(postion)
      })
      return list
    }

    GetTerrainPosition (lng: number, lat: number) {
      const height = this.viewer.scene.globe.getHeight(Cesium.Cartographic.fromDegrees(lng, lat, 0))
      return {
        lng: lng,
        lat: lat,
        height: height
      }
    }
}

export default DrawCircleTool
